/**
 * Video
 * Pop-up video modals
 */

<template>
  <div>
    <div @click="open" style="cursor: pointer;"><slot name="trigger"></slot></div>

    <div class="modal" @click="close" :class="{ 'is-viewing': isOpen }">
      <div class="modal-inner" @click.stop="close" ref="modal">
        <div class="video">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
    <div class="modal-screen" @click="close"></div>
  </div>
</template>

<script>
import { Vimeo } from '../lib';

module.exports = {
  data() {
    return {
      isOpen: false,
    };
  },
  created: function() {
    const vue = this;
    document.addEventListener('keydown', (e) => {
      if(e.which === 27) {
        vue.close();
      }
    });
  },
  methods: {
    close: function() {
      this.isOpen = false;
      Vimeo.pause(this.$refs.modal.querySelector('iframe'));
      document.body.classList.remove('is-modal-viewing');
    },

    open: function() {
      this.isOpen = true;
      Vimeo.play(this.$refs.modal.querySelector('iframe'));
      document.body.classList.add('is-modal-viewing');
    },
  },
}
</script>



// WEBPACK FOOTER //
// components/Video.vue